var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBboxicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40473_24410)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_40473_24410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.32657 13.1991C-2.95934 11.0655 -2.18009 8.78315 -0.37898 7.49467L1.12779 6.41676C2.73962 5.2637 4.85915 5.06063 6.68662 5.88417L11.4711 8.04028C15.0054 9.63301 14.4218 14.7748 10.6287 15.4613C8.89659 15.7747 7.5978 17.2008 7.44867 18.945C7.0736 23.3315 0.855709 23.9291 -0.402084 19.6881L-2.32657 13.1991Z",
    fill: "#2D00E0",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_40473_24410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.233 12.2913C27.0257 10.2488 26.5465 7.94686 25 6.36825L22.4414 3.75664C21.6505 2.94935 20.6049 2.42233 19.4702 2.25914L17.3731 1.95752C12.9575 1.32244 10.3707 6.64688 13.6817 9.55576C14.1939 10.0058 14.5929 10.5643 14.8479 11.1884L15.341 12.3955C17.3103 17.2153 24.3479 17.1479 26.233 12.2913Z",
    fill: "#7D00E0",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_40473_24410)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.85742,
    y: 7.83105,
    width: 10.2857,
    height: 1.02857,
    rx: 0.514286,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_40473_24410)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.85742,
    y: 11.4863,
    width: 10.2857,
    height: 1.02857,
    rx: 0.514286,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_40473_24410)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.85742,
    y: 15.1414,
    width: 10.2857,
    height: 1.02857,
    rx: 0.514286,
    fill: "white"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 9.85798,
    cy: 8.34431,
    r: 1.28571,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.1431,
    cy: 11.9996,
    r: 1.28571,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.85798,
    cy: 15.6558,
    r: 1.28571,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_40473_24410",
    x: -18.543,
    y: -10.6165,
    width: 48.3672,
    height: 49.1877,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_40473_24410"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_40473_24410",
    x: -3.81836,
    y: -14.0945,
    width: 46.4277,
    height: 46.0669,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_40473_24410"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_40473_24410",
    x: 2.85742,
    y: 4.83105,
    width: 18.2852,
    height: 9.02856,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.290196 0 0 0 0 0 0 0 0 0 0.878431 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_40473_24410"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_40473_24410",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_40473_24410",
    x: 2.85742,
    y: 8.48633,
    width: 18.2852,
    height: 9.02856,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.290196 0 0 0 0 0 0 0 0 0 0.878431 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_40473_24410"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_40473_24410",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_40473_24410",
    x: 2.85742,
    y: 12.1414,
    width: 18.2852,
    height: 9.02856,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.290196 0 0 0 0 0 0 0 0 0 0.878431 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_40473_24410"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_40473_24410",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40473_24410"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBboxicon);
export default __webpack_public_path__ + "static/media/bboxicon.b42e056a8d95d1763f6a1b5581655bbf.svg";
export { ForwardRef as ReactComponent };